export const ChartDataIcon = ({ className }: { className: string }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path
            d="M8.666 11.333V6M12 11.334v-8M2 2v10.667A1.333 1.333 0 0 0 3.333 14H14M5.333 11.334v-2"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
